import React, { useContext, useRef, useEffect, useState } from "react";
import "./Skills.scss";

import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import { illustration, skillsSection } from "../../portfolio";
import { Fade } from "react-reveal";
import emoji from "react-easy-emoji";
import * as d3 from 'd3';
import graphData from './Greeting_Network.json';
import codingPerson from "../../assets/lottie/codingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import StyleContext from "../../contexts/StyleContext";
function setWork(experience_name) {
  console.log(experience_name);
  var skillsHeading = document.getElementsByClassName("subTitle skills-text-subtitle")[0];

  var bullets = document.getElementsByClassName("subTitle skills-text");
  bullets[3].innerHTML = "";
  switch (experience_name) {
    case "Topic Modeling":
      skillsHeading.innerHTML = "Topic Modeling (2 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML = "<img src=\"/umap_projection.png\" width=80%/>";

      bullets[1].innerHTML =
        "⚡ Familiar with AI-based BERTopic methods, as well as LDA and NMF modeling."

      bullets[2].innerHTML =
        "⚡ Most recent experience: Created a BERTopic modeling of truck driver forum posts on autonomous vehicles for presentation at the American Sociological Association Conference. Information available upon request."

      break;
    case "Network Analysis":
      skillsHeading.innerHTML = "Network Analysis (4 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML = "<img src=\"/bidentrump_modul_density1.png\" width=80%/>";

      bullets[1].innerHTML =
        "⚡ Familiar with community detection and contagion algorithms in static and temporal networks."

      bullets[2].innerHTML =
        "⚡ Most recent experience: Mapping social media data from trucking forums to determine importance of location proximity in similar views of turnover intention."

      break;
    
    case "Java":
      skillsHeading.innerHTML = "Java (3 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML =
        "⚡ Proficient in elements of the Java 8 framework."
      bullets[1].innerHTML =
        "⚡ Intermediate understanding of JDBC interaction with AWS and MySQL instances."
      bullets[2].innerHTML =
        "⚡ Most recent experience: Creating a Java framework for temporal graph visualization."

      break;
    case "MySQL":
      skillsHeading.innerHTML = "MySQL (2 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML =
        "⚡ Intermediate-Advanced Understanding of MySQL DDL and DML queries."
      bullets[1].innerHTML =
        "⚡ Familiar with incorportation of embedded SQL within Python and Java applications."
      bullets[2].innerHTML =
        "⚡ Most recent experience: Using MySQL queries for preliminary filtering for Java-based data analysis."

      break;
    case "Social Media":
      skillsHeading.innerHTML = "Social Media Analysis (6 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML =
        "⚡ Proficient in using common tools such as BrandWatch, Social Studio, Sprinklr, etc."
      bullets[1].innerHTML =
        "⚡ Familiar with common data gathering pipelines and REST APIs."
      bullets[2].innerHTML =
        "⚡ Recent experience: Analysis of hundreds of thousands of Twitter posts around gig work to understand public perceptions of essential workers during the Covid-19 pandemic."

      break;
    case "Data Mining":
      skillsHeading.innerHTML = "Data Mining (3 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML =
        "⚡ Familiar with information retrieval techniques and pipelines."
      bullets[1].innerHTML =
        "⚡ Experience with data aggregation using REST and GraphQL APIs, as well as data extraction from social media platforms."
      bullets[2].innerHTML =
        "⚡ Recent experience: Utilized data ingestion algorithms to conduct autonomous research on subjects of interests for private investigations."

      break;
    case "Amazon AWS":
      skillsHeading.innerHTML = "Amazon AWS (3 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML =
        "⚡ Familiar with managing and operating integrated EC2/RDS instances."
      bullets[1].innerHTML =
        "⚡ Past work has involved embedding instances into Python and Java frameworks."
      bullets[2].innerHTML =
        "⚡ Recent experience: AWS instances for temporary web hosting."

      break;
    
    case "Statistics":
      skillsHeading.innerHTML = "Statistics (4 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML =
        "⚡ Acadmic publications of statistical analysis on social media and survey data."
      bullets[1].innerHTML =
        "⚡ Familiar with various regression algorithms, Bayesian statistics, and optimization algorithms."
      bullets[2].innerHTML =
        "⚡ Most Recent experience: Moderated OLS Regression to determine the influence of topic polarization on political discourse."

      break;
    case "Python":
      skillsHeading.innerHTML = "Python (7 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML =
        "⚡ Advanced understanding of common libraries (pandas, numpy, matplotlib, NetworkX, etc.)"
      bullets[1].innerHTML =
        "⚡ Previously used for data analysis in both private consulting and acadmeic research."
      bullets[2].innerHTML =
        "⚡ Most Recent experience: Use of Python for the creation of the Social OSPREY backend.";

      break;
    case "Web Scraping":
      skillsHeading.innerHTML = "Web Scraping (4 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML =
        "⚡ Familiar with common web scraping libraries (BeautifulSoup, Selenium, etc.)"
      bullets[1].innerHTML =
        "⚡ Previously used for data analysis in both private consulting and acadmeic research."
      bullets[2].innerHTML =
        "⚡ Most Recent experience: Used a common web scraping library to autonomously gather data from social media platforms.";

      break;
    case "Report Generation":
      skillsHeading.innerHTML = "Report Generation (4 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML =
        "⚡ Built a comprehensive platform that uses Python-based docxtpl along with Jinja templates to completely replicate reports previously done manually."
      bullets[1].innerHTML =
        "⚡ Previously used for data analysis in both private consulting and acadmeic research."

      break;
    case "Google Cloud Platform":
      skillsHeading.innerHTML = "Google Cloud Platform (2 Years)";
      document.getElementsByClassName("software-skills-main-div")[0].style.display = "none";
      bullets[0].innerHTML =
        "⚡ Handled a full industry application deployment on the Google Cloud Platform, including the use of Google Cloud Run, Google Cloud Storage, and comprehensive IAM policies to ensure data security."
      bullets[1].innerHTML =
        "⚡ Connected a full deployment to a CI/CD pipeline using Cloud Build and Google Artifact Registry."
      bullets[2].innerHTML =
        ""

      break;
  }
}
export default function Skills() {
  const { isDark } = useContext(StyleContext);


  const svgRef = useRef();
  const [info, setInfo] = useState('Click a node to see its name here');

  useEffect(() => {
    // Function to get responsive dimensions based on screen size
    const getResponsiveDimensions = () => {
      const isMobile = window.innerWidth <= 768;
      const isTablet = window.innerWidth <= 1024 && window.innerWidth > 768;
      
      if (isMobile) {
        return { width: 300, height: 400 };
      } else if (isTablet) {
        return { width: 400, height: 500 };
      } else {
        return { width: 500, height: 600 };
      }
    };

    const { width, height } = getResponsiveDimensions();
    
    // Clear previous SVG content
    d3.select(svgRef.current).selectAll("*").remove();
    
    const svg = d3.select(svgRef.current)
      .attr("width", width)
      .attr("height", height)
      .style("max-width", "100%")
      .style("height", "auto");

    const colorScale = d3.scaleOrdinal()
      .domain(graphData.nodes.map(d => d.id))
      .range([
        "#FFB3BA", "#FFDFBA", "#FFFFBA", "#BAFFC9", "#BAE1FF",
        "#DECBA4", "#D4A5A5", "#A5D4C3", "#B7D3F2", "#F2A5D3"
      ]);

    // Adjust force simulation parameters based on screen size
    const isMobile = window.innerWidth <= 768;
    const linkDistance = isMobile ? 100 : 150;
    const chargeStrength = isMobile ? -200 : -400;

    const simulation = d3.forceSimulation(graphData.nodes)
      .force("link", d3.forceLink(graphData.links).id(d => d.id).distance(linkDistance))
      .force("charge", d3.forceManyBody().strength(chargeStrength))
      .force("center", d3.forceCenter(width / 2, height / 2));

    const drag = d3.drag()
      .on("start", (event, d) => {
        if (!event.active) simulation.alphaTarget(0.3).restart();
        d.fx = d.x;
        d.fy = d.y;
      })
      .on("drag", (event, d) => {
        d.fx = Math.max(15, Math.min(width - 15, event.x));
        d.fy = Math.max(15, Math.min(height - 15, event.y));
      })
      .on("end", (event, d) => {
        if (!event.active) simulation.alphaTarget(0);
        d.fx = null;
        d.fy = null;
      });

    // Adjust node size based on screen size
    const nodeRadius = isMobile ? 10 : 15;

    const link = svg.append("g")
      .attr("class", "links")
      .selectAll("line")
      .data(graphData.links)
      .enter().append("line")
      .attr("class", "link")
      .attr("stroke", "#999")
      .attr("stroke-opacity", 0.6)
      .attr("stroke-width", isMobile ? 1 : 1.5);

    const node = svg.append("g")
      .attr("class", "nodes")
      .selectAll("circle")
      .data(graphData.nodes)
      .enter().append("circle")
      .attr("class", "node")
      .attr("r", nodeRadius)
      .attr("fill", d => colorScale(d.id))
      .attr("fill-opacity", 0.5)
      .on("click", (event, d) => setWork(d.id))
      .call(drag);

    // Adjust font size for labels based on screen size
    const fontSize = isMobile ? "10px" : "12px";

    const label = svg.append("g")
      .selectAll("text")
      .data(graphData.nodes)
      .enter().append("text")
      .attr("dx", 0)
      .attr("text-anchor", "middle")
      .attr("dy", ".55em")
      .style("font-size", fontSize)
      .style("pointer-events", "none") // Prevent text from interfering with node clicks
      .text(d => d.id);

    simulation.nodes(graphData.nodes).on("tick", () => {
      link
        .attr("x1", d => d.source.x)
        .attr("y1", d => d.source.y)
        .attr("x2", d => d.target.x)
        .attr("y2", d => d.target.y);

      node
        .attr("cx", d => d.x = Math.max(nodeRadius, Math.min(width - nodeRadius, d.x)))
        .attr("cy", d => d.y = Math.max(nodeRadius, Math.min(height - nodeRadius, d.y)));

      label
        .attr("x", d => d.x)
        .attr("y", d => d.y);
    });

    simulation.force("link").links(graphData.links);

    // Add resize listener to handle window resizing
    const handleResize = () => {
      const newDimensions = getResponsiveDimensions();
      if (newDimensions.width !== width || newDimensions.height !== height) {
        // Re-run the effect with new dimensions
        setTimeout(() => {
          // This will trigger a re-render with new dimensions
          window.dispatchEvent(new Event('resize'));
        }, 100);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      simulation.stop();
    };

  }, []);
  if (!skillsSection.display) {
    return null;
  }
  return (
    <div className={isDark ? "dark-mode main" : "main"} id="skills">
      <div className="skills-main-div">
        <Fade left duration={1000}>
          <div className="skills-image-div">
            {/* {illustration.animated ? (
              <DisplayLottie animationData={codingPerson} />
            ) : (
              <img
                alt="Man Working"
                src={require("../../assets/images/developerActivity.svg")}
              ></img>
            )} */}
            <svg ref={svgRef}></svg>

          </div>
        </Fade>
        <Fade right duration={1000}>
          <div className="skills-text-div">
            <h1
              className={isDark ? "dark-mode skills-heading" : "skills-heading"}
            >
              {skillsSection.title}{" "}
            </h1>
            {skillsSection.subTitle && (
              <p
                className={
                  isDark
                    ? "dark-mode subTitle skills-text-subtitle"
                    : "subTitle skills-text-subtitle"
                }
              >
                {skillsSection.subTitle}
              </p>
            )}
            <SoftwareSkill />
            <div>
              {skillsSection.skills.map((skills, i) => {
                return (
                  <p
                    key={i}
                    className={
                      isDark
                        ? "dark-mode subTitle skills-text"
                        : "subTitle skills-text"
                    }
                  >
                    {skills}
                  </p>
                );
              })}
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}
